/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Käyttökertojen määrä',
    BLACK_FRIDAY_COMISSION_TITLE: 'Mustan perjantain palkkiot {0}',
    BLACK_FRIDAY_COMMISSION: 'Mustan perjantain palkkiot {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Mustan perjantain palkkiot {0}',
    COMISSION_DESCRIPTION: 'Kuluvan kuukauden aikana laskettu kokonaismäärä:',
    COMISSION_LAST_MONTH: 'Homologinen',
    COMISSION_LAST_TEN: 'Viimeiset {0} päivät',
    COMISSION_TITLE: 'Palkkiot {0} päivää:',
    COMMISSION: 'Komissio',
    COMMISSION_COLUMN: 'Komissio (€)',
    DAILY: 'Päiväkirja',
    DATE: 'Päivämäärä',
    FEMALE: 'Nainen',
    FIFTY_DAYS: '50 päivää',
    GENDER: 'Sukupuoli',
    HITS: 'Pääsy {0} päivää:',
    HITS_DESCRIPTION: 'Pääsy',
    HOMOLOGOUS: 'Homologinen',
    HOMOLOGOUS_LAST_YEAR: 'Edellinen vuosi',
    MALE: 'Mies',
    NAME: 'Nimi',
    NEW_CUSTOMERS: 'Uudet asiakastilit {0} päivää:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Uudet Prozisin vuosipäivän asiakastilit',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Uudet tilit odottavat tilausta {0} päivää:',
    NO_SALES: 'Ei myyntiä',
    ORDER_PENDING_CUSTOMERS: 'Tilillä oleva tilaus',
    ORDERED_CUSTOMERS: 'Uusi asiakastili',
    ORDERS: 'Tilaukset {0} päivää:',
    ORDERS_DESCRIPTION: 'Maksettu viimeisten 6 kuukauden aikana',
    ORDERS_DETAIL_DESCRIPTION: 'Maksua odottavat maksut {0} päivää:',
    ORDERS_PAY: 'Maksetut maksut',
    ORDERS_PENDING: 'Maksamattomat maksut',
    PERCENTAGE: 'Prosenttiosuus',
    PRODUCT_CATEGORY: 'Hierarkia',
    PRODUCT_COLUMN: 'Tuote',
    QT_COLUMN: 'Määrä',
    QUANTITY: 'Määrä',
    SALES: 'Myynti',
    SALES_DESCRIPTION: 'Kuluva kuukausi',
    SALES_PRODUCT: 'Myynti tuotehierarkian mukaan',
    TEN_DAYS: '10 päivää',
    THIRTEEN_DAYS: '30 päivää',
    TOP_COMMISSION_TITLE: 'Parhaat tilatut tuotteet',
    TOP_DESCRIPTION: 'Kuluva kuukausi',
    TOP_GENDER_DESCRIPTION: 'Viimeiset {0} päivät',
    TOP_GENDER_TITLE: 'Suurin myynti sukupuolen mukaan',
    TOP_TITLE: 'Parhaiten myydyt artikkelit',
    TWENTY_DAYS: '20 päivää',
    UPDATED_AT: 'Päivitetty {0}',
    VALUE: 'Arvo'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Tiedot puuttuvat',
    EMPTY_TITLE: 'Ei tuloksia'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
